import { BaseModel } from '../base-model';
export interface IAppointmentPlaceSuggestionParameterModel {
  AppointmentTypeId?: number;
  PropertyId?: string;
  PersonId?: string;
  UserId?: number;
  Keyword?: string;
}

export class AppointmentPlaceSuggestionParameterModel extends BaseModel<IAppointmentPlaceSuggestionParameterModel> implements IAppointmentPlaceSuggestionParameterModel {
  AppointmentTypeId: number;
  PropertyId: string;
  PersonId: string;
  UserId: number;
  Keyword: string;
  /**
   *
   */
  constructor(options?: { [key: string]: any }) {
    super(options);
  }
}

